<template>
  <div class="service x-height-100">
    <template v-if="list.length">
      <my-left-menu class="left-menu" width="200px">
        <ul class="list x-height-100 x-flex-y x-scrollbar-show">
          <li
            v-for="(item, index) in list"
            :class="[{ active: active == item.name }]"
            @click="clickItem(item)"
          >
            {{ item.name }}
          </li>
        </ul>
      </my-left-menu>
      <div class="right-view x-padding x-flex-one x-flex-y x-scrollbar-show">
        <div class="x-border-50 x-margin-b">
          <my-head-title :title="active"></my-head-title>
          <div class="x-padding-info">
            <div class="ul-item" v-if="formData.request">
              <my-info-item
                :title="$t('HT.service.url')"
                :info="formData.request.uri"
              ></my-info-item>
              <my-info-item
                :title="$t('HT.apiStepThree.method')"
                :info="formData.request.method"
              ></my-info-item>
              <my-info-item
                :title="$t('HT.apiStepThree.remark')"
                :info="formData.remark"
              ></my-info-item>
            </div>
          </div>
        </div>
        <div class="x-border-50 x-margin-b">
          <my-head-title :title="$t('HT.apiInfo.title2')"></my-head-title>
          <div class="x-padding" v-if="formData.request">
            <ux-table
              ref="table"
              :hide-on-single-page="true"
              :showPage="false"
              :emptyText="$t('HT.nodata')"
              :data="formData.request.parameters || []"
              :columns="columns1"
              layout="total, sizes, prev, pager, next"
            ></ux-table>
          </div>
        </div>
        <div class="x-border-50 x-flex-one">
          <my-head-title :title="$t('HT.generateApi.title')"></my-head-title>
          <div class="x-padding" v-if="formData.response">
            <el-input
              v-model="formData.response.succeeded"
              type="textarea"
              size="small"
              readonly
              :autosize="{ minRows: 10, maxRows: 10 }"
            ></el-input>
          </div>
        </div>
      </div>
    </template>
    <div v-show="isNo" class="x-blank-img"></div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      active: '', // 默认服务
      list: [], // 服务列表
      columns1: [
        // 入参定义表
        {
          label: this.$t('HT.apiStepTwo.paramsName'),
          prop: 'name',
          tooltip: true
        },
        {
          label: this.$t('HT.apiStepThree.origin'),
          prop: 'position',
          tooltip: true
        },
        {
          label: this.$t('HT.upgrade.type'),
          prop: 'type',
          tooltip: true
        },
        {
          label: this.$t('HT.required'),
          prop: 'required',
          tooltip: true,
          formatter: (row, column, cellValue) => {
            return JSON.stringify(cellValue);
          }
        },
        {
          label: this.$t('HT.default'),
          prop: 'default_value',
          tooltip: true
        },
        {
          label: this.$t('HT.example'),
          prop: 'example',
          tooltip: true
        },
        {
          label: this.$t('HT.apiStepOne.remark'),
          prop: 'remark',
          tooltip: true
        }
      ],
      isNo: false,
      formData: {}
    };
  },

  created() {
    this.getList();
  },
  methods: {
    /**
     * 获取列表
     * @param {Object} params 查询对象
     */
    getList(params) {
      this.$uxLoading.show();
      this.$api.service.getWord(params).then((res) => {
        if (res.code == 10000) {
          this.list = res.data;
          if (this.list[0]) {
            this.active = this.list[0]['name'];
            this.getWordInfo(this.list[0]['id']);
          } else {
            this.isNo = true;
          }
        }
      });
    },

    /**
     * 获取信息
     * @param {String} id 唯一标识
     */
    getWordInfo(id) {
      this.$uxLoading.show();
      this.$api.service.getWordInfo(id).then((res) => {
        if (res.code == 10000) {
          this.formData = res.data;
        }
      });
    },

    clickItem(item) {
      this.active = item.name;
      this.getWordInfo(item['id']);
    }
  }
};
</script>

<style lang="scss" scoped>
.service {
  display: flex;

  .list {
    > li {
      text-align: center;
      padding: 10px 20px;
      cursor: pointer;

      &:hover {
        color: #0087ff;
      }
    }

    .active {
      color: #0087ff;
    }
  }

  .ul-item {
    display: flex;
    flex-wrap: wrap;

    .info-item {
      width: 50%;
    }
  }

  .right-view {
    width: 0;
  }
}
</style>
